import { render, staticRenderFns } from "./GeneralEditProduct.vue?vue&type=template&id=58b1aa3c&"
import script from "./GeneralEditProduct.vue?vue&type=script&lang=js&"
export * from "./GeneralEditProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports